import script from "./QiuuPageDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./QiuuPageDetail.vue?vue&type=script&setup=true&lang=js"

import "./QiuuPageDetail.vue?vue&type=style&index=0&id=4b37e04c&lang=less"
import "./QiuuPageDetail.vue?vue&type=style&index=1&id=4b37e04c&lang=less&scoped=true"
import "./QiuuPageDetail.vue?vue&type=style&index=2&id=4b37e04c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b37e04c"]])

export default __exports__